import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_IAP } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Payment',
        key: 'IAP',
        name: 'IAP',
        icon: 'far fa-money-bill-alt',
        route: { name: ROUTE_NAME_IAP.INDEX }
    }
]);

export default registerRouteForModule(router);
